<template>
  <div class="de_box">
    <div class="title">
      <div class="tab_lf">
        <span class="red-icon"></span>
        <span>{{title}}</span>
      </div>
    </div>
    <div class="con_box" v-if="info" v-html="info">
    </div>
  </div>
</template>

<script>
  // import { configResource } from '@/resource/resource'
  import {mapState, mapMutations} from 'vuex'
  // const ERR_OK = 0
  export default {
    props: ['title', 'code', 'info'],
    name: 'detailbox',
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
    },
    mounted () {
    },
    methods: {
        // 更新vuex状态信息
      ...mapMutations([
        'CONFIG_INFO'
      ])
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .de_box
    margin-top 0.2rem
    color $c-b1
    .title
      height 0.8rem
      line-height @height
      font-size $fz-t3
      color $c-b1
      width 100%
      background-color #fff
      display flex
      justify-content space-between
      .tab_lf
        display flex
        align-items center
        .red-icon
          display inline-block
          width 0.06rem
          height 0.32rem
          margin 0 0.20rem 0 0.28rem
          background-color $blue
          border-radius 0.02rem
    .con_box
      overflow-x auto
      font-size $fz-t3
      border-top 1px solid #ccc
      padding 0.2rem 0.28rem
      background-color #fff
      word-break break-all
      line-height 0.4rem
      // max-height 2.9rem
      box-sizing border-box
      // overflow-y scroll
      td 
          border-top: 1px solid #333;
          border-left: 1px solid #333;
      table
          border-right: 1px solid #333;
          border-bottom: 1px solid #333;
      tr:nth-child(odd)
          background: #fff;
      tr:nth-child(even)
          background: gray;
      tr:hover
          background: yellow;
</style>



// WEBPACK FOOTER //
// src/components/common/detailbox/detailbox.vue